<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <h1>Inicio sesión</h1>
                <p class="text-muted">Administración facturando</p>
                <div class="alert alert-danger" v-if="error != ''">
                  <ul v-html="errors"></ul>
                </div>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="fa fa-user"></i></span>
                  <input type="text" class="form-control" v-model="credentials.email" placeholder="Correo electrónico">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                  <input type="password" v-model="credentials.password" class="form-control" placeholder="Contraseña">
                </div>
                <br>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn btn-primary px-4" @click="auth">Iniciar sesión</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 justify-content-center">
          <img class="logo" src="http://facturandomexico-4041.kxcdn.com/logotipo.png">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'

export default {
  name: 'Login',
  components: {},
  data () {
    return {
      credentials: {
        email: '',
        password: '',
        recaptcha: ''
      },
      error: ''
    }
  },
  computed: {
    errors () {
      let error = ''
      for (let propiedad in this.error) {
        error += '<li>' + this.error[propiedad] + '</li>'
      }
      return error
    }
  },
  methods: {
    verified (data) {
      this.credentials.recaptcha = data
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    auth () {
      let vue = this
      let response = store.dispatch('authLogin', this.credentials)
      response.then(response => {
        store.state.token = response.data.token
        vue.$router.push('/distribuidores')
      }).catch(error => {
        vue.error = error.response.data
      })
    }
  }
}
</script>
<style scoped>
.login {
  display: block;
    position: relative;
    float: right;
    height: 40px;
    width: auto;
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/Login.vue